import { render } from "./DeclineReason.vue?vue&type=template&id=5faa870d&scoped=true"
import script from "./DeclineReason.vue?vue&type=script&lang=js"
export * from "./DeclineReason.vue?vue&type=script&lang=js"

import "./DeclineReason.vue?vue&type=style&index=0&id=5faa870d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faa870d"]])

export default __exports__